import { render, staticRenderFns } from "./mo-bulk-processing.html?vue&type=template&id=95aabf36&external"
import script from "./mo-bulk-processing.ts?vue&type=script&lang=ts&external"
export * from "./mo-bulk-processing.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-bulk-processing.vue?vue&type=style&index=0&id=95aabf36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports